<div *ngIf="control?.invalid && errorMessages?.length">
   <ng-container *ngFor="let message of errorMessages; let i = index">
      <small class="mensage">{{
         message.label?.replace('{number}', message.requiredLength )
      }}</small>
   </ng-container>
</div>
